import { appConfig } from '@stencil/hotels-config'

const { BASE_VOYAGER_SEARCH_URL } = appConfig

 const locationAndHotelSearchURL = ({
  inputValue,
  limit = 10,
  cityId,
  showHotels = true
}: {
  inputValue: string;
  limit?: number;
  cityId: number;
  showHotels: boolean;
   }) => {
  
  const params = JSON.stringify({
    search_query: inputValue,
    city_filter_id: cityId,
    limit,
    qt: 'D',
    inc_ggl_res: true,
    include_t: ['voy.area', 'voy.landmark', 'ggl.area', 'ggl.landmark', ...[
      ...(showHotels) ? ['voy.hotel'] : []
    ]],
  });
  return `${BASE_VOYAGER_SEARCH_URL}?&params=${params}`;
 };


export default locationAndHotelSearchURL;